import { ReactNode } from 'react';

import { Link } from '@mui/material';
import { navigate } from '@reach/router';

import brandConfigs from 'config/brand-resolution';

import { useStyles } from './styles';

const TextLink = ({ children, to }: { children: ReactNode; to: string }) => {
  const classes = useStyles();
  return (
    <Link
      className={classes.link}
      onClick={() => {
        navigate(to);
      }}
      color={brandConfigs.theme.brandColor}
    >
      {children}
    </Link>
  );
};

export default TextLink;
